export default __webpack_public_path__ + "static/media/403-error-forbidden-amico.65a705bc.svg";